import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import FloatingContactButtons from "@/components/site/FloatingContactButtons";
import DiscoveryCallBar from "@/components/site/DiscoveryCallBar";
import CookieConsent from "@/components/site/CookieConsent";
import Home from "@/pages/Home";
import CoursesPage from "@/pages/CoursesPage";
import CourseDetail from "@/pages/CourseDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import EnrollPage from "@/pages/EnrollPage";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import IpTrainingPage from "@/pages/IpTrainingPage";
import PatentServices from "@/pages/PatentServices";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <SmoothScroll>
          <DiscoveryCallBar />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ip-training" element={<IpTrainingPage />} />
              <Route path="/patent-services" element={<PatentServices />} />
              <Route path="/courses" element={<CoursesPage />} />
              <Route path="/courses/:slug" element={<CourseDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/enroll" element={<EnrollPage />} />
              <Route path="/enroll/:slug" element={<EnrollPage />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
          <FloatingContactButtons />
          <CookieConsent />
          <Toaster
            position="bottom-left"
            toastOptions={{
              className: "font-sans",
              style: {
                border: "1px solid rgba(198,168,124,0.35)",
                borderRadius: "0px",
                background: "#0B2038",
                color: "#F5F4F0",
              },
            }}
          />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
